import { render, staticRenderFns } from "./ItemRL_List.vue?vue&type=template&id=f3789dda"
import script from "./ItemRL_List.vue?vue&type=script&lang=js"
export * from "./ItemRL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports